module.exports = __webpack_public_path__ + "static/media/c9bannerModul3_small.ef460655.jpg";